// extracted by mini-css-extract-plugin
export default {"container":"TR-z","darkBackground":"UR-z","whiteBackground":"VR-z","headerButton":"WR-z","calloutHeading":"XR-z","calloutSubHeading":"YR-z"};